export default __webpack_public_path__ + "static/media/MasarTal.8227058d.webp";